import React, { StatelessComponent } from 'react';

type AdminTabProps = {
  link?: string;
  isActive?: boolean;
};

const AdminTab: StatelessComponent<AdminTabProps> = ({
  isActive,
  link,
  children,
}) => (
  <li
    className={`jg-space-mtms jg-space-mhsm@md jg-space-pbsm jg-space-pln${
      isActive ? ' jg-pages-admin-tabs--active' : ''
    }`}
  >
    <a href={link} className="jg-space-phsm jg-text--large-regular">
      {children}
    </a>
  </li>
);

export default AdminTab;
